import axios from 'axios'
import React, { useEffect } from 'react'
import { useState } from 'react'
import { SERVER_URL } from '../config'
import { countAndSetPages } from '../utils/countAndSetPages'

export const Types = ({setItems, setPages, setSelectedPage, selectedType, selectedBrand, setSelectedType}) => {
  const [types, setTypes] = useState([])

  useEffect(() => {
    loadTypes()
  }, []);

  const loadTypes = async () => {
    await axios.get(SERVER_URL + "/api/type").then((response) => {
      setTypes(response.data)
    })
  }

  const selectType = async (id) => {
    setSelectedType(id)
    const response = await axios.get(SERVER_URL + `/api/item?typeId=${id}${selectedBrand ? `&brandId=${selectedBrand}`: ""}`)
    setItems(response.data.rows)
    setSelectedPage(1)
    countAndSetPages(response, setPages)
  }

  return (
    <ul className="types">
      {types.map(type =>
        <li key={type.id}
          className={`type ${type.id === selectedType ? "selected" : ""}`}
        >
          <button onClick={() => selectType(type.id)} className={"button-default black-tablet"}>
            {type.name.length < 20 ? type.name : `${type.name.substr(0, 20)}..`}
          </button>
        </li>
      )}
    </ul>
  )
}
